import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchExamInstructionRequest,
  getPyqTopicWiseSetsRequest,
  setPaperId,
  setSelectedSetId,
  setTestDetails,
  setTestType,
  submitExamRequest,
} from "../../../../../redux/exam/examSlice";
import "./PyqTopicWiseSet.css";
import { useHistory } from "react-router-dom";
import images from "../../../../../utilities/images/images";
import GameficationMode from "../../../../tests/Dashboard/GameficationMode";
import ResumeModal from "../../../../../shared/components/Modal/ResumeModal/ResumeModal";
import {
  getFormatForApi,
  resolveMediaUrl,
} from "../../../../../custom_utilities/pyqFormatUtils";

const SetCardIcon = ({ icon }) => {
  const resolvedIcon = useMemo(
    () => resolveMediaUrl(icon),
    [icon]
  );
  const [src, setSrc] = useState(resolvedIcon);

  useEffect(() => {
    setSrc(resolvedIcon);
  }, [resolvedIcon]);

  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      className="card-icon"
      referrerPolicy="no-referrer"
      onError={() => setSrc(images.resume_practice_icon)}
    />
  );
};

const PyqTopicWiseSet = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    pyqTopicWiseSets,
    activeSubject,
    selectedTopic,
    plannerDetails,
    selectedType,
    paperName,
    testDetails,
    loadingTopicWiseSets,
    error,
  } =
    useSelector((state) => state.examSlice);

  const pyqFormatForApi = getFormatForApi({
    format: testDetails?.format,
    paperName,
    selectedType,
  });

  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
  } = plannerDetails || {};
  const isExamCrackerFlow =
    Number(paperType) === 6 ||
    Number(paperType) === 8 ||
    Number(paperType) === 9;

  const currentTopicTitle =
    selectedTopic?.topic_name ||
    selectedTopic?.name ||
    pyqTopicWiseSets?.topic_name ||
    pyqTopicWiseSets?.topic ||
    (isExamCrackerFlow ? "Exam Cracker" : "Topic Wise Set");

  const [gmOpen, setGmOpen] = useState(false);
  const [selectedSet, setSelectedSet] = useState(null);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const getResumeStorageKey = (set) => `exam_mode_${set?.set_id}`;
  const getGamificationStorageKey = (set) =>
    `exam_gamification_${set?.set_id}`;
  const getResumeModeConfig = (set) => {
    const activeTestId =
      testDetails?.testId || testDetails?.setId || testDetails?.paperId;
    const isSameActiveTest = String(activeTestId) === String(set?.set_id);

    const storedMode = localStorage.getItem(getResumeStorageKey(set));
    const backendMode =
      storedMode ||
      set?.practiceMode ||
      set?.practice_mode ||
      set?.mode ||
      set?.selected_mode ||
      set?.last_mode ||
      (isSameActiveTest ? testDetails?.practiceMode : undefined);
    const normalizedMode =
      String(backendMode || "").toLowerCase() === "practice"
        ? "practice"
        : "test";
    const storedGamification = localStorage.getItem(
      getGamificationStorageKey(set)
    );
    const gamificationOn =
      storedGamification === "1" ||
      set?.gamificationOn === true ||
      set?.gamification_on === 1 ||
      set?.gamification_status === 1 ||
      set?.is_gamification === 1 ||
      (isSameActiveTest && testDetails?.gamificationOn === true);

    return {
      selectedMode: normalizedMode,
      gamificationOn: normalizedMode === "practice" ? gamificationOn : false,
    };
  };

  /* ===================== FETCH SETS ===================== */
  useEffect(() => {
    if (activeSubject && selectedTopic?.topic_name) {
      dispatch(
        getPyqTopicWiseSetsRequest({
          subject: activeSubject,
          topic: selectedTopic.topic_name,
          ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
          paper_type: paperType,
          category_id: category_id || paperType,
        })
      );
    }
  }, [dispatch, activeSubject, selectedTopic, pyqFormatForApi, paperType, category_id]);

  /* ===================== OPEN GAMIFICATION MODAL ===================== */
  const handleFooterClick = (set) => {
    setSelectedSet(set);
    setGmOpen(true);
  };
  const handleResumeClick = (set) => {
    setSelectedSet(set);
    setShowResumeModal(true);
  };

  /* ===================== CONFIRM GAMIFICATION ===================== */
  const handleGamificationConfirm = ({ selectedMode, gamificationOn }) => {
    if (!selectedSet) return;

    // const paperId =
    //   selectedSet.paper_id || selectedSet.test_id || selectedSet.set_id;

    // const testId = selectedSet.test_id || selectedSet.set_id;
    const paperId = undefined;
const testId = undefined;

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId,
      testId,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: selectedMode,
      gamificationOn,
      forceFreshStart: true,
      isResume: false,
      source: "topicwise",          
    };
    localStorage.setItem(getResumeStorageKey(selectedSet), selectedMode || "test");
    localStorage.setItem(
      getGamificationStorageKey(selectedSet),
      gamificationOn ? "1" : "0"
    );

    dispatch(setTestDetails(payload));
    dispatch(fetchExamInstructionRequest(payload));

    setGmOpen(false);
    history.push("/TestInstruction");
  };
  const handleResumeContinue = () => {
    if (!selectedSet) return;
    const resumeConfig = getResumeModeConfig(selectedSet);

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: resumeConfig.selectedMode,
      gamificationOn: resumeConfig.gamificationOn,
      forceFreshStart: false,
      isResume: true,
      source: "topicwise",
    };
    dispatch(setTestDetails(payload));
    setShowResumeModal(false);
    history.push("/test", {
      paperType: payload.paperType,
      setId: payload.setId,
    });
  };

  const handleResumeSubmit = () => {
    if (!selectedSet) return;
    const resumeConfig = getResumeModeConfig(selectedSet);

    dispatch(setSelectedSetId(selectedSet.set_id));
    dispatch(setTestType({ id: paperType }));

    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      categoryId: category_id || "",
      setId: selectedSet.set_id,
      practiceMode: resumeConfig.selectedMode,
      gamificationOn: resumeConfig.gamificationOn,
      forceFreshStart: false,
      isResume: true,
      source: "topicwise",
    };
    dispatch(setTestDetails(payload));
    dispatch(
      submitExamRequest({
        paperType: payload.paperType,
        paperId: payload.paperId,
        plannerId: payload.plannerId,
        setId: payload.setId,
        time: 0,
      })
    );
    setShowResumeModal(false);
    history.push(
      payload.practiceMode === "practice" ? "/practice-summary" : "/analytics"
    );
  };

  /* ===================== UI STATES ===================== */
  if (loadingTopicWiseSets) {
    return <div className="loading">Loading sets...</div>;
  }

  if (error) {
    return <div className="loading">Unable to load sets. Please try again.</div>;
  }

  if (!pyqTopicWiseSets?.sets || pyqTopicWiseSets.sets.length === 0) {
    return <div className="loading">No sets available for this topic.</div>;
  }

  const getButton = (set) => {
  if (set.is_subscribed === 0) {
    return (
      <button
        className="practice-btn locked-btn"
        onClick={() => {
          if (set?.package_id) {
            history.push(`/package/${set.package_id}`);
          } else {
            history.push("/dashboard/courses");
          }
        }}
      >
        Locked
      </button>
    );
  }

  const resumeKey = `exam_resume_state_${set.set_id}`;
  const hasResume = !!localStorage.getItem(resumeKey);
  const showResumeFromApi =
    Number(set?.show_resume) === 1 || set?.show_resume === true;

  if (hasResume || showResumeFromApi) {
    return (
      
      <button
        className="practice-btn resume-btn"
        onClick={() => handleResumeClick(set)}
      >
        {getResumeModeConfig(set).selectedMode === "practice"
          ? "Resume Practice"
          : "Resume Test"}
      </button>
    );
  }

  const attemptCount = Number(set?.user_attempt_count || 0);
  const hasShowReattemptFlag = set?.show_reattempt !== undefined;
  const shouldShowReattempt = hasShowReattemptFlag
    ? Number(set.show_reattempt) === 1
    : attemptCount > 0;

  if (shouldShowReattempt) {
    return (
      <button
        className="practice-btn reattempt-btn"
        onClick={() => handleFooterClick(set)}
      >
        Reattempt ({attemptCount})
      </button>
    );
  }

  return (
    <button
      className="practice-btn start-btn"
      onClick={() => handleFooterClick(set)}
    >
      Start Test
    </button>
  );
};
  /* ===================== RENDER ===================== */
  const handleAnalyticsClick = (set) => {
    const payload = {
      paperId: undefined,
      testId: undefined,
      paperType,
      plannerId: planner_id,
      plannerTypeId: planner_type_id,
      categoryId: category_id || "",
      setId: set.set_id,
      planner_test_id: undefined,
      source: "topicwise",
      returnTo: "/practice/topic-wise/pyqset",
      show_practice: set.show_practice,
      attempt_message: set.attempt_message,
      user_attempt_count: set.user_attempt_count,
      test_name: set.set_name || "",
    };

    dispatch(setSelectedSetId(set.set_id));
    dispatch(setTestType({ id: paperType }));
    dispatch(setPaperId(null));
    dispatch(setTestDetails(payload));

    history.push("/analytics", {
      paper_type: paperType,
      set_id: set.set_id,
      returnTo: "/practice/topic-wise/pyqset",
    });
  };
  return (
    <>
      <div className="topic-wise-header">
        <img
          src={images.new_backarrow}
          alt="Back"
          // style={{ width: "24px", height: "24px", cursor: "pointer" }}
          onClick={() => history.push("/practice/topic-wise")}
        />
        <h3 className="header-title">
          {currentTopicTitle}
        </h3>
      </div>

      <div className="container">
        <div className="wrapper">
          <div className="grid">
            {pyqTopicWiseSets.sets.map((set) => {
               const isCompleted = set.analytics_visible === 1;
      return(
              <div key={set.set_id} className="card-pyq">
                <div className="card-header">
                  <div className="circle">
                    <SetCardIcon icon={set.icon || set.icon_url || set.set_icon} />
                  </div>

                  <div className="card-info">
                    <h3 className="set-name">{set.set_name}</h3>
                    <p className="set-details">
                      {set.total_questions} Questions
                      {set?.year_range ? <br /> : null}
                      {set?.year_range ? `(${set.year_range})` : ""}
                    </p>
                  </div>
                   <div className="card-top-icon" 
                    style={{
    cursor: isCompleted ? "pointer" : "not-allowed",
    opacity: isCompleted ? 1 : 0.5,
  }}
  onClick={() => {
    if (isCompleted) handleAnalyticsClick(set);
  }}>
                    
                <img src={images.topicanalytics_icon} alt="stats icon" />
                </div>
                </div>
                <div className="card-footer">{getButton(set)}</div>
              </div>
      );
            })}
          </div>
        </div>
      </div>

      {/* ===================== GAMIFICATION MODAL ===================== */}
      <GameficationMode
        isOpen={gmOpen}
        attemptUsed={selectedSet?.user_attempt_count || 0}
        attemptMessage={selectedSet?.attempt_message}
        testName={selectedSet?.set_name}
        onClose={() => setGmOpen(false)}
        onConfirm={handleGamificationConfirm}
      />
      <ResumeModal
        isOpen={showResumeModal}
        onClose={() => setShowResumeModal(false)}
        onSubmit={handleResumeSubmit}
        onResume={handleResumeContinue}
        resumeLabel={
          getResumeModeConfig(selectedSet).selectedMode === "practice"
            ? "Resume Practice"
            : "Resume Test"
        }
      />
    </>
  );
};

export default PyqTopicWiseSet;
